import SignInCode from '@/modules/auth/code/sign-in-code';
import { createFileRoute } from '@tanstack/react-router';
import z from 'zod';

const searchSchema = z.object({
  code: z.string().optional(),
});

export const Route = createFileRoute('/auth/code')({
  component: RouteComponent,
  validateSearch: (search) => searchSchema.parse(search),
});

function RouteComponent() {
  const { code } = Route.useSearch();
  return <SignInCode browserCode={code} />;
}
